export default __webpack_public_path__ + "static/media/step-forward-solid.f82d1c9a.svg";